export const routeParamSymbol = '/:';
/**
 * Turns "/homegames/clubs/:clubId?/:section?/:subsection?"
 * into
 * "/homegames/clubs"
 */
export const stripRouteParams = (pathname: string) => {
  if (pathname.includes(routeParamSymbol)) {
    return pathname.slice(0, pathname.indexOf(routeParamSymbol));
  }

  return pathname;
};
